<template>
  <CRow>
    <CCol col="12" md="7">
        <CCard>
    <CCardHeader>
        <p> <img src="img/cow (2).svg" style="width:20px">&nbsp;Body Score</p>
        </CCardHeader>
           <CCardBody>
  <CDataTable
          :items="unionItem"
          :fields="fields"
          table-filter
          items-per-page-select
          :items-per-page="10"
          sorter
          pagination
          clickable-rows
          hover
          @row-clicked="rowClicked"
          caption="Breed"
        />
        </CCardBody>
        </CCard>
    </CCol>
    <CCol col="6" md="5">
      <CCard>
          <CCardHeader>
           <p> <img src="img/cow (2).svg" style="width:20px">&nbsp;Body Score Details</p>
           
          </CCardHeader>
          <CCardBody>
            <CForm>
                  
             <CInput
               
                label="Id No"
                horizontal
                autocomplete="name"
                name="unionCode"
                id="unionCode"
                required
                v-model="idNo"
              />
                
                  
             <CInput
               
                label="Score Date"
                horizontal
                type="date"
                autocomplete="name"
                  name="unionName"
                id="unionName"
                required
                 v-model="scoreDate"
              />
                 <CInput
               
                label="Body Score"
                horizontal
                autocomplete="name"
                name="bodyscore"
                id="bodyscore"
                required
                 v-model="bodyscore"
              />
                 <CInput
               
                label="udder score"
                horizontal
                autocomplete="name"
                 name="udderscore"
                id="udderscore"
                required
                 v-model="udderscore"
              />
                 <CInput
               
                label="Utreus Score"
                horizontal
                autocomplete="name"
                 name="utreusScore"
                id="utreusScore"
                required
                 v-model="utreusScore"
              />
               
 
             </CForm>

          </CCardBody>
           <CCardFooter>
                  <CButton color="info" style="width:100px" v-if="addButton" @click="addChilling">
                    <CIcon name="cilPencil" />&nbsp;Add
                  </CButton>&nbsp;
                  <CButton
                    color="success"
                    style="width:100px"
                    v-if="saveButton"
                    @click="updateChilling"
                  >
                    <CIcon name="cilCheck" />&nbsp;Save
                  </CButton>&nbsp;
                  <CButton
                    color="danger"
                    style="width:100px"
                    v-if="deleteButton"
                    @click="deleteChilling"
                  >
                    <CIcon name="cilXCircle" />&nbsp;Delete
                  </CButton>&nbsp;
<CButton color="success" style="width:100px" v-if="EditsaveButton" @click="addChilling">
            <CIcon name="cilCheck" />&nbsp;Save
          </CButton>&nbsp;


                  <CButton
                    color="secondary"
                    style="width:100px"
                    v-if="cancelButton"
                    @click="CancelChilling"
                  >
                    <CIcon name="cilWarning" />&nbsp;Cancel
                  </CButton> &nbsp;
                   <CButton
                    color="info"
                   
                    v-if="addnewButton"
                    @click="addnewChillingplus"
                  >
                    <CIcon name="cilPencil" />&nbsp;Add New
                  </CButton>
                </CCardFooter>
        </CCard>
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from '../../tables/Table'
import { APIService } from "../../../apiservice.js";
import Swal from "sweetalert2";
export default {
     components: { CTableWrapper },
 
  data () {
    return{
      unionItem:[],
      editchilling:[],
      idNo:null,
      scoreDate:"",
      bodyscore:"",
      udderscore:"",
      utreusScore:"",
     addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton:true,
      cancelButton:false,
      EditsaveButton:false,
       fields: [
      {
        key: "idNo",
        sortable: true
      },
      {
        key: "scoreDate",
        sortable: true
      },
       
         {
        key: "bodyscore",
        sortable: true
      },
        {
        key: "udderscore",
        sortable: true
      },
    
    {
        key: "utreusScore",
        sortable: true
      },
      
    ],
   
    }
  },
  methods: {
   getbodyScoreList() {
      APIService.bodyScoreList().then(res => {
        if (res.status == 200) {
          this.unionItem= res.data;

           this.idNo =   this.unionItem[0].idNo;
      this.scoreDate = this.unionItem[0].scoreDate;
      this.bodyscore = this.unionItem[0].bodyscore;
      this.udderscore = this.unionItem[0].udderscore;
        this.utreusScore = this.unionItem[0].utreusScore;
        }
      });
    },
  
    rowClicked(item, index, column, e) {
      console.log("edit item", item, index, column, e);

      this.editchilling = item;
       this.idNo = item.idNo;
      this.scoreDate = item.scoreDate;
      this.bodyscore = item.bodyscore;
      this.udderscore = item.udderscore;
        this.utreusScore = item.utreusScore;
       this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton =false;
      this.addnewButton=true;
     
    },
    addChilling() {
      let idNo = this.idNo;
      let scoreDate = this.scoreDate;
      let bodyscore = this.bodyscore;
        let udderscore = this.udderscore;
      let utreusScore = this.utreusScore;
      let data = {
      idNo,
      scoreDate,
      bodyscore,
      udderscore,
      utreusScore
      };
      APIService.saveBodyScore(data).then(res => {
        if (res.status == 200) {
          this.idNo = null;
          this.scoreDate = "";
          this.bodyscore = "";
          this.udderscore="",
          this.utreusScore=""
         this.getbodyScoreList();
            Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },
    addnewChillingplus(){
        this.idNo = null;
          this.scoreDate = "";
          this.bodyscore = "";
          this.udderscore="",
          this.utreusScore=""
        this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton =true;
          this.addnewButton=false;
           this.EditsaveButton=true    
          return getbodyScoreList();
         
    },
    
    CancelChilling(){
      this.idNo = null;
          this.scoreDate = "";
          this.bodyscore = "";
          this.udderscore="",
          this.utreusScore=""
        this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton =false;
          this.addnewButton=true;
           this.EditsaveButton=false,
        this.getbodyScoreList();
    },
    updateChilling() {
      let id = this.editchilling._id;
           let idNo = this.idNo;
      let scoreDate = this.scoreDate;
      let bodyscore = this.bodyscore;
        let udderscore = this.udderscore;
      let utreusScore = this.utreusScore;
          
      let value = {
         idNo,
      scoreDate,
      bodyscore,
      udderscore,
      utreusScore
      };
      let data = { id, value };
      APIService.bodyScoreUpdate(data).then(res => {
        if (res.status == 200) {
        this.idNo = null;
          this.scoreDate = "";
          this.bodyscore = "";
          this.udderscore="",
          this.utreusScore=""
            this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
           this.cancelButton =false;
           this.addnewButton=true;
     this.getbodyScoreList();
          Swal.fire({
  position: 'center',
  icon: 'success',
  title: 'Data Saved Successfully',
  showConfirmButton: false,
  timer: 2000
})
        }
      });
    },


 deleteChilling() {
//     Swal.fire({
//   title: 'Are you sure?',
//   text: "You won't be able to revert this!",
//   icon: 'warning',
//   showCancelButton: true,
//   confirmButtonColor: '#3085d6',
//   cancelButtonColor: '#d33',
//   confirmButtonText: 'Yes, delete it!'
// }).then((result) => {
//   if (result.value) {
//     Swal.fire(
//       'Deleted!',
//       'Your file has been deleted.',
//       'success'
//     )
//   }
//   this.delete();
// })

const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-success',
    cancelButton: 'btn btn-danger'
  },
  buttonsStyling: false
})

swalWithBootstrapButtons.fire({
  title: 'Are you sure?',
  text: "You won't be able to revert this!",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: 'Yes, delete it!',
  cancelButtonText: 'No, cancel!',
  reverseButtons: true
}).then((result) => {
  if (result.value) {
    swalWithBootstrapButtons.fire(
      'Deleted!',
      'Your file has been deleted.',
      'success'
    )
     this.delete();
  } else if (
    /* Read more about handling dismissals below */
    result.dismiss === Swal.DismissReason.cancel
  ) {
    swalWithBootstrapButtons.fire(
      'Cancelled',
      'Your imaginary file is safe :)',
      'error'
    )
  }
})



  }, delete(){
      let id = this.editchilling._id;
      let data = { id };
      APIService.bodyScoreDelete(data).then(res => {
        if (res.status == 200) {
         this.idNo = null;
          this.scoreDate = "";
          this.bodyscore = "";
          this.udderscore="",
          this.utreusScore=""
             this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
           this.cancelButton =false;
             this.addnewButton=true;
              this.EditsaveButton=false,
           this.getbodyScoreList();
        }
      });


      
    }
  },
  created() {
    // this.getBreedList();
    this.getbodyScoreList();
  }
  
}
</script>
